import { useCartFreeIntroSessionGuard } from './hooks/useCartFreeIntroSessionGuard'

export const CartProviderGuards = () => {
  useCartFreeIntroSessionGuard()

  return null
}
